import StateInterface from "../state-interface";

export const property_translations: StateInterface["property_translations"] = {
	_id: "",
	property_id: "",
	property_slug: "",
	locale: "en-IN",
	content: {
		title: "",
		cover_image_caption: "",
		short_description: "",
		overview_pointers: [],
		about_property_description: "",
		project_highlights: [],
		floor_plans: [],
		location_title: "",
		about_location_pointers: [],
		vicinity: [],
		builder: {
			name: "",
			description: "",
		},
		amenities: [],
		amenities_description: "",
		cta_caption: "",
		faqs: [],
		seo: {
			meta_title: "",
			meta_description: "",
			keywords: [],
		},
	},
	status: "draft",
	created_at: "",
	updated_at: "",
	last_updated_by: "",
};

export default property_translations;
